import { useEffect, useState } from "react";

// The real question is "can this visitor install a desktop plugin right now",
// not "is this an iPhone", so this is a capability check and never a
// user-agent sniff. Requiring a coarse pointer AND a narrow viewport keeps
// touchscreen laptops and large tablets on the desktop path, which already
// converts and must not be disturbed.
const QUERY = "(pointer: coarse) and (max-width: 768px)";

export function useIsHandheld() {
  const [isHandheld, setIsHandheld] = useState(
    () => typeof window !== "undefined" && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (event) => setIsHandheld(event.matches);
    mq.addEventListener("change", onChange);
    // Re-sync in case the query flipped between first render and this effect.
    setIsHandheld(mq.matches);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isHandheld;
}
